import { notQualifiedTypes } from 'config/notQualifiedTypes';
import { submitReferralCodeApi } from 'api/client';
import Cookies from 'js-cookie';

export default async function getLoginUserNonQualifyTypeAfterEntry(state) {
    const {
        promo: { uuid: promoUuid } = {},
        promoState: { referralCode },
        userEntryState: {
            currentEntryUUID: entryUuid,
            isNeedEnterReferralCode,
            hasReferralCodeInput
        } = {},
        userGameResultRecords = [],
        settingMGMReferral: { enableReferralCodeRequired } = {}
    } = state;

    const submitReferralCode = async () => {
        const emptyState = {
            promoState: {
                referralCode: ''
            }
        };

        if (referralCode && promoUuid && entryUuid) {
            Cookies.remove('ref_code');
            try {
                const submitResp = await submitReferralCodeApi({
                    promoUuid,
                    entryUuid,
                    referralCode
                });
                if (submitResp.httpStatus === 200) {
                    return {
                        userEntryState: {
                            hasReferralCodeInput: true,
                            isNeedEnterReferralCode: false,
                            isCanEnterReferralCode: false
                        },
                        ...emptyState
                    };
                } else {
                    return {
                        ...emptyState,
                        ...(enableReferralCodeRequired
                            ? {
                                  userLoginState: {
                                      notQualifiedType:
                                          notQualifiedTypes.QUALIFICATION.SUBMIT_REFERRAL_CODE
                                  }
                              }
                            : {})
                    };
                }
            } catch (err) {
                return {
                    ...emptyState,
                    ...(enableReferralCodeRequired
                        ? {
                              userLoginState: {
                                  notQualifiedType:
                                      notQualifiedTypes.QUALIFICATION.SUBMIT_REFERRAL_CODE
                              }
                          }
                        : {})
                };
            }
        } else {
            return {
                ...(enableReferralCodeRequired
                    ? {
                          userLoginState: {
                              notQualifiedType: notQualifiedTypes.QUALIFICATION.SUBMIT_REFERRAL_CODE
                          }
                      }
                    : {})
            };
        }
    };

    if (referralCode && userGameResultRecords.length === 0) {
        if (hasReferralCodeInput) {
            return {
                promoState: {
                    referralCode: ''
                }
            };
        }
        const res = await submitReferralCode();
        if (Boolean(res)) return res;
    } else if (isNeedEnterReferralCode) {
        return {
            promoState: {
                referralCode: ''
            },
            userLoginState: {
                notQualifiedType: notQualifiedTypes.QUALIFICATION.SUBMIT_REFERRAL_CODE
            }
        };
    }

    return {};
}
